import * as styles from "./TabLayout.css";

import type { JSX } from "react";

import { Separator } from "@frontend/components/atoms/Separator";

import { ClassificationSection } from "./ClassificationSection";
import { IdentitySection } from "./IdentitySection";
import { Interlocutors } from "./Interlocutors";
import { ProvenanceSection } from "./ProvenanceSection";
import { TabColumn } from "./TabColumn";

export function MainInformations(): JSX.Element {
  return (
    <div className={styles.tab}>
      <div className={styles.columns}>
        <TabColumn>
          <IdentitySection />

          <ClassificationSection />

          <ProvenanceSection />
        </TabColumn>

        <Separator orientation="vertical" className={styles.separator} />

        {/* The people alone on the right, as the project editor has them. */}
        <TabColumn>
          <Interlocutors />
        </TabColumn>
      </div>
    </div>
  );
}
